import { flatObjectToInterface } from "../common";
/**
 * A variant of the unsafe converter that starts to migrate data away from flatObjectToInterface and interfaceDataToFlatObject
 *
 * This converter is for cases where you want to start storing e.g. arrays as actual arrays in Firestore, rather than an
 * object with a _dataStructureIsArray property.
 *
 * It's only OK to use this converter if:
 *  - Your data does not use ES6 Maps or Sets
 *  - You're not querying for arrays expecting their values to become object properties once persisted
 *  - You don't need metadata support (i.e. you already use the "none" metadata strategy)
 *
 * When using this converter, we still use flatObjectToInterface upon reading data, but we expect it to receive and deal
 * with arrays as arrays, without complaining (we use an option to suppress the warning). We no longer use interfaceDataToFlatObject
 * when persisting data. Meaning this converter is a step towards removing the need for these functions, because round-tripping
 * data will convert the data back to the original format.
 */
export class UnsafeToPlainMigrationAdminConverter {
    toFirestore(modelObject) {
        return modelObject;
    }
    fromFirestore(snapshot) {
        return flatObjectToInterface(snapshot.data(), { warnOnNonFlatObject: false });
    }
}
export class UnsafeToPlainMigrationClientConverter {
    toFirestore(modelObject) {
        return modelObject;
    }
    fromFirestore(snapshot) {
        return flatObjectToInterface(snapshot.data(), { warnOnNonFlatObject: false });
    }
}
//# sourceMappingURL=UnsafeToPlainMigrationConverter.js.map